import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getCommentsFailed,
  getCommentsStart,
  getCommentsSuccess,
} from "../redux/getComments";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { getListCommentAPI } from "core/http/service/news";
import { SCREEN } from "helper/roleChecker/Screens";

function* getCommenst(action) {
  const payload = action.payload;
  const { controlPage } = yield select(controlInfinitiveScrollSelector);
  const params = {
    ...controlPage,
    objectId: payload.objectId,
    screenCode: payload.screenCode ?? SCREEN.IP_009,
    type: payload.type ?? "POST",
  };
  try {
    const res = yield call(getListCommentAPI, params);
    yield put({
      type: getCommentsSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getCommentsFailed.type,
    });
  }
}

function* watchGetComments() {
  yield takeLatest(getCommentsStart.type, getCommenst);
}

export default function* getCommentsSaga() {
  yield all([watchGetComments()]);
}
